import axios from "axios";

interface branchProds {
  platform?: string;
  merchantId?: string;
  branchId?: string;
}

export async function getBranch({
  platform,
  merchantId,
  branchId,
}: branchProds) {
  const res = await axios.get(
    `api/v1/${platform}/branch/${merchantId}/${branchId}`
  );

  return res && res.data;
}

export async function getImagesLibraryFromMerchant({ platform }: any) {
  const response = await axios.get(
    `${process.env.REACT_APP_GATEWAY_API}/api/v1/${platform}/merchant/pictures`
  );
  return response && response.data;
}

export async function uploadImageFromMerchant(formData: any) {
  const response = await axios.post(
    `${process.env.REACT_APP_ASSETS_URL}/api/v1/upload/image`,
    formData
  );
  return response;
}

export async function saveImageFromMerchant(payload: {
  name: string;
  origin_url: string;
}) {
  const response = await axios.post(
    `${process.env.REACT_APP_GATEWAY_API}/api/v1/retail/merchant/save-picture`,
    {
      name: payload.name,
      origin_url: payload.origin_url,
    }
  );

  return response;
}

export function merchantActive(merchantId: string, branchId: string) {
  return axios.put(
    `${process.env.REACT_APP_GATEWAY_API}/api/v1/retail/merchant/${merchantId}/last-time-visit`,
    {
      branch_id: branchId,
    }
  );
}

export async function getPageBuilderDemo({ theme_code, platform, page }: any) {
  const res = await axios.post(
    `api/v1/${platform}/merchant/preview-theme/${theme_code}`, {
      ...page && { page },
    }
  );
  return res && res.data;
}

export const getLocaleSettings = async () => {
  const response = await axios.get(
    `api/v2/merchants/branch/config-language-currency`
  );
  if (response.status === 200 && response.data) {
    return {
      success: true,
      data: { ...response.data.data },
    };
  }
  return {
    success: false,
    data: {},
  };
};

export const updateLocaleSettings = async (payload: {
  language: string;
  currency: string;
  languages: string[];
  ignore_phrases?: string[];
}) => {
  const response = await axios.put(
    `api/v2/merchants/branch/language-currency`,
    payload
  );

  if (response.status === 200) {
    return {
      success: true,
    };
  }
  return {
    success: false,
  };
};
